import PageHeader from "../components/PageHeader";
import CTABanner from "../components/CTABanner";
import { INDUSTRIES } from "../lib/content";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";

export default function Industries() {
  return (
    <div data-testid="industries-page">
      <PageHeader
        eyebrow="Our Industries"
        title="Seven industries. One disciplined house."
        subtitle="BNM Group structures physical trade across rail, aviation, petrochemicals, machinery, agriculture, heavy equipment and telecommunications."
        image="https://static.prod-images.emergentagent.com/jobs/992269a5-240d-47a2-94bf-57af67715604/images/4acbb80021f186925ac20fcacc521c5700b6a298dc53aa81bd022cefc5f6a531.png"
        testId="industries-page-header"
      />

      <section className="py-20 sm:py-28 bg-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-10">
          {INDUSTRIES.map((ind, i) => (
            <motion.article
              key={ind.id}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.6, delay: (i % 2) * 0.1 }}
              data-testid={`industry-card-${ind.id}`}
              className="group bg-white border border-[#E3E6EC] overflow-hidden hover-lift"
            >
              <Link to={`/industries/${ind.id}`} className="block">
                <div className="relative aspect-[16/10] overflow-hidden bg-[#0A1F3F]">
                  <img
                    src={ind.image}
                    alt={ind.title}
                    className="w-full h-full object-cover opacity-90 transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                  <div className="absolute top-4 left-4 w-11 h-11 bg-[#F37021] text-white font-display font-black text-base flex items-center justify-center">
                    {ind.number}
                  </div>
                </div>
                <div className="p-8">
                  <h2 className="font-display font-black tracking-tighter text-2xl sm:text-3xl text-[#0A1F3F] leading-[1.1]">
                    {ind.title}
                  </h2>
                  <p className="mt-4 text-sm text-[#4B5668] leading-relaxed">
                    {ind.description}
                  </p>
                  <div className="mt-6 inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-semibold text-[#F37021]">
                    Learn more
                    <ArrowUpRight className="w-4 h-4" />
                  </div>
                </div>
              </Link>
            </motion.article>
          ))}
        </div>
      </section>

      <CTABanner />
    </div>
  );
}
